var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRandom6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.e{fill:#fff;font-family:SegoeUI, Segoe UI;}.a{font-size:4px;}.b{fill:#656565;}.c{fill:#728153;}.d{fill:#95b633;}.e{font-size:3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-72 -456)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "a",
    transform: "translate(80 487)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "enter")), /*#__PURE__*/React.createElement("text", {
    className: "a",
    transform: "translate(96 487)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "elumini")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(130 725) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8 218)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 50,
    height: 18
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0,0H50V17H0Z",
    transform: "translate(0 18)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M0,0H50V17H0Z",
    transform: "translate(0 34)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "e",
    transform: "translate(36 41) rotate(180)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "elumini oudoing")))), /*#__PURE__*/React.createElement("text", {
    className: "e",
    transform: "translate(86 499.256)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "enter")), /*#__PURE__*/React.createElement("text", {
    className: "e",
    transform: "translate(99 499.256)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "elumini")), /*#__PURE__*/React.createElement("text", {
    className: "e",
    transform: "translate(86 482)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "elumini oudoing")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRandom6);
export default __webpack_public_path__ + "static/media/random6.a211ecd094a27ae6c1b0724f930451f9.svg";
export { ForwardRef as ReactComponent };